import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { useConfigurationAttributeScrolling } from "../NavigationState/useConfigurationScrolling";
/**
 * Wrapper for attributes with support for theming
 */
const MuiAttributeWrapper = styled("div", {
    name: "MuiAttributeWrapper",
    slot: "root",
})(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));
/**
 * @deprecated This component was deprecated in favor of CSSGrid based layout implementation. Go to {@linkcode AttributeWrapper} for the new implementation.
 * Generic wrapper for attributes
 *
 * Wraps attribute headline and control element
 */
export function LegacyAttributeWrapper(props) {
    const { id, isAllowed, path, isComplete, isRequired } = useCsAttribute();
    const elementRef = useConfigurationAttributeScrolling();
    const notAllowedProps = isAllowed
        ? {}
        : {
            pointerEvents: "none",
            opacity: 0.75,
        };
    return (_jsx(MuiAttributeWrapper, { ref: elementRef, id: path, className: "attribute-wrapper", sx: Object.assign({}, notAllowedProps), "data-is-complete": isComplete, "data-is-required": isRequired, "data-attribute-path": path, "data-attribute-id": id, children: props.children }));
}
//# sourceMappingURL=LegacyAttributeWrapper.js.map